import React from 'react'
import PropTypes from 'prop-types'
import {graphql, StaticQuery} from 'gatsby'
import urlJoin from 'url-join'


const LatestNewsQuery = ({className, children, limit, excludeArticleSlug}) => <StaticQuery query={graphql`
{
  allNewsJsonWithRelativePaths(sort: {fields: createdAt, order: DESC}, filter: {show: {ne: false}}) {
    nodes {
      createdAt
      title
      excerpt
      slug
    }
  }

  newsPage: file(relativePath: {eq: "pages/newsPage.json"}) {
		childPagesJson {
			url
		}
	}
}

`} render={(data) => {
	const {nodes: rawArticles} = data.allNewsJsonWithRelativePaths
	const {url: baseUrl} = data.newsPage.childPagesJson
	const articles = rawArticles
		.filter(one => one.slug !== excludeArticleSlug)
		.slice(0, limit)
		.map(one => ({...one, link: urlJoin(baseUrl, one.slug)}))

	return children({articles, total: rawArticles.length})
}}/>

LatestNewsQuery.propTypes = {
	className: PropTypes.string,
	children: PropTypes.func.isRequired,
	excludeArticleSlug: PropTypes.string.isRequired,
	limit: PropTypes.number,
}

LatestNewsQuery.defaultProps = {
	className: '',
	excludeArticleSlug: null,
	limit: 6,
}

export default LatestNewsQuery
